<template>
	<!--div id="app"-->
		<router-view />
	<!--/div-->
</template>

<script>
export default {
	name: "App",
	components: {},
	data: () => ({}),
};
</script>

<style lang="scss">
body {
	background: #324413;
}

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	background: rgb(233, 233, 233);
	position: relative;
}

#nav {
	padding: 30px;

	a {
		font-weight: bold;
		color: #2c3e50;

		&.router-link-exact-active {
			color: #42b983;
		}
	}
}
</style>
